import { render, staticRenderFns } from "./package-addon-component.vue?vue&type=template&id=19a2f5bc"
import script from "./package-addon-component.vue?vue&type=script&lang=js"
export * from "./package-addon-component.vue?vue&type=script&lang=js"
import style0 from "./package-addon-component.vue?vue&type=style&index=0&id=19a2f5bc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports